import React from 'react';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import styles from './titleDetail.module.scss';

export default function TitleDetail({
    title,
    children
}: {
    title: string;
    children: JSX.Element | JSX.Element[];
}): JSX.Element {
    return (
        <div>
            <Typography variant={TypographyVariants.BODY_BOLD} component="p" className={styles.titleDetail}>
                {title}
            </Typography>
            {children}
        </div>
    );
}
